"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBannerAnalyticsType = getBannerAnalyticsType;
exports.transformGdprConsent = transformGdprConsent;
function getBannerAnalyticsType(esiType) {
    switch (esiType) {
        case "broad":
            return "ocbanner";
        case "browse":
        case "search":
            return "banner";
        default:
            return "banner";
    }
}
function transformGdprConsent(gdprConsent) {
    if (typeof gdprConsent !== "string") {
        return "false";
    }
    gdprConsent = gdprConsent.trim().toLowerCase();
    if (gdprConsent === "1") {
        return "true";
    }
    return "false";
}
